/**
 * EnterpriseQueueSkeleton — Skeleton loading para fila de demandas.
 */
import React from 'react';

interface EnterpriseQueueSkeletonProps {
  rows?: number;
}

export const EnterpriseQueueSkeleton: React.FC<EnterpriseQueueSkeletonProps> = ({ rows = 4 }) => (
  <ul className="divide-y divide-slate-100 dark:divide-[var(--border-default)]">
    {Array.from({ length: rows }).map((_, i) => (
      <li key={i} className="animate-pulse px-3 py-2.5">
        <div className="flex items-center justify-between gap-2">
          <div className="flex gap-1.5">
            <div className="h-4 w-14 rounded-sm bg-slate-200 dark:bg-slate-700" />
            <div className="h-4 w-16 rounded-sm bg-slate-100 dark:bg-slate-800" />
          </div>
          <div className="h-3 w-12 rounded bg-slate-100 dark:bg-slate-800" />
        </div>
        <div className="mt-2 h-3.5 w-3/4 rounded bg-slate-200 dark:bg-slate-700" />
        <div className="mt-2 grid grid-cols-2 gap-1">
          <div className="h-2.5 rounded bg-slate-100 dark:bg-slate-800" />
          <div className="h-2.5 rounded bg-slate-100 dark:bg-slate-800" />
          <div className="h-2.5 rounded bg-slate-100 dark:bg-slate-800" />
          <div className="h-2.5 rounded bg-slate-100 dark:bg-slate-800" />
        </div>
      </li>
    ))}
  </ul>
);

export default EnterpriseQueueSkeleton;
